export const getToken = () => {
  const { token = '' } = JSON.parse(
    sessionStorage.getItem('USER_INFO') || '{}'
  );
  return token;
};
